module.exports = __webpack_public_path__ + "img/20200613_141633.01da3822.jpg";